import type { MetricBreakdownRow } from '../types';
import { formatMetric, labelize } from '../lib/format';

interface BreakdownBarChartProps {
  title: string;
  description: string;
  rows: MetricBreakdownRow[];
  metric: string;
  emptyMessage?: string;
  label?: (value: string) => string;
  maxRows?: number;
}

export function BreakdownBarChart({
  title,
  description,
  rows,
  metric,
  emptyMessage = 'No evidence yet',
  label = labelize,
  maxRows = 8
}: BreakdownBarChartProps) {
  const visible = rows
    .filter((row) => typeof row.metrics[metric] === 'number')
    .sort((left, right) => (right.metrics[metric] || 0) - (left.metrics[metric] || 0))
    .slice(0, maxRows);
  const maximum = Math.max(1, ...visible.map((row) => row.metrics[metric] || 0));

  return <section className="panel breakdown-card">
    <div className="panel__header"><div><h2>{title}</h2><p>{description}</p></div></div>
    {visible.length ? <div className="breakdown-chart">{visible.map((row) => {
      const value = row.metrics[metric] || 0;
      return <div className="breakdown-chart__row" key={row.label}>
        <div className="breakdown-chart__label"><strong>{label(row.label)}</strong>{row.combinedGroups ? <small>{row.combinedGroups} small cohorts combined</small> : null}</div>
        <div className="breakdown-chart__track" aria-hidden="true"><span style={{ width: `${Math.max(2, value / maximum * 100)}%` }} /></div>
        <strong className="breakdown-chart__value">{formatMetric(metric, value)}</strong>
      </div>;
    })}</div> : <div className="breakdown-chart__empty">{emptyMessage}</div>}
  </section>;
}
